import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Image } from 'react-bootstrap';

import userImage from '../../Assets/avatar-user-default.jpg'
import './style.css';



// Local Components

class HsgToggle extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    render() {
        return (
        <div 
            className="hsg-header-user-root"
            onClick={this.handleToggleClick}>

            {this.props.children}

        </div>);
    }
    
    handleToggleClick(e) {
        e.preventDefault();

        this.props.onClick(e);
    }
}


class HsgMenu extends Component {
    render() {
        return (
        <div
            className="dropdown-menu hsg-header-user-menu"
            onClick={this.props.onClick}>
            
            {this.props.children}

        </div>);
    }
}



// Primary Component

export default class HeaderUser extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showMenu: false
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.onClickMenu = this.onClickMenu.bind(this);
    }


    render() {
        return (
        <Dropdown
            id="hsg-header-user-dropdown"
            open={this.state.showMenu}
            onToggle={this.handleToggle}>

            <HsgToggle bsRole="toggle">

                <Image className="hsg-profile-guy" src={userImage}/>
                
                <span className="hsg-header-user-name">{this.props.name}</span>

                <span className="hsg-header-user-dropdown-icon"><i className="fas fa-sort-down" /></span>

            </HsgToggle>


            <HsgMenu bsRole="menu" onClick={this.onClickMenu}>

                {this.props.children}

            </HsgMenu>

        </Dropdown>);
    }


    handleToggle() {
        const status = !this.state.showMenu;
        this.setState({showMenu: status});
    }


    onClickMenu() {
        this.setState({showMenu: false});
    }

}



HeaderUser.propTypes = {
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string
};






// WEBPACK FOOTER //
// ./src/Components/HeaderUser/index.js